if (!customElements.get('tss-nested-navigation')) {
  document.addEventListener('toggle', (event) => {
    if (!(event.target instanceof HTMLDetailsElement) || !event.target.closest('header-drawer')) return;
    event.target.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(event.target.open));
  }, true);

  customElements.define('tss-nested-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggleButton = this.querySelector('.tss-subnav__toggle');
      this.panel = this.querySelector('.tss-subnav__panel');
      this.scope = this.closest('header-drawer') || this.closest('.mega-menu__content');
      if (!this.toggleButton || !this.panel || !this.scope) return;
      this.panel.hidden = true;
      this.toggleButton.hidden = false;
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.dataset.ready = '';

      // Dawn attaches close actions to drawer buttons. Handle this disclosure
      // during capture, before the button's unrelated drawer-close listener.
      this.addEventListener('click', (event) => {
        if (!this.toggleButton.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        this.panel.hidden ? this.open() : this.close();
      }, { ...options, capture: true });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.preventDefault();
          event.stopPropagation();
          this.consumeEscape = true;
          this.close(true);
        } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && event.target === this.toggleButton) {
          event.preventDefault();
          this.open();
          const links = this.panel.querySelectorAll('a');
          (event.key === 'ArrowUp' ? links[links.length - 1] : links[0])?.focus();
        }
      }, options);
      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && this.consumeEscape) {
          event.stopPropagation();
          this.consumeEscape = false;
        }
      }, options);

      for (let ancestor = this.parentElement; ancestor; ancestor = ancestor.parentElement) {
        if (ancestor instanceof HTMLDetailsElement) {
          const details = ancestor;
          details.addEventListener('toggle', () => { if (!details.open) this.close(); }, options);
        }
      }
      this.breakpoint = matchMedia('(min-width: 990px)');
      this.breakpoint.addEventListener('change', () => this.close(), options);
    }

    open() {
      this.scope.querySelectorAll('tss-nested-navigation').forEach((other) => {
        if (other !== this) other.close();
      });
      this.panel.hidden = false;
      this.toggleButton.setAttribute('aria-expanded', 'true');
    }

    close(restoreFocus = false) {
      if (!this.panel || !this.toggleButton) return;
      this.panel.hidden = true;
      this.toggleButton.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.toggleButton.focus();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
